/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S9_Li4_PreInputs */

const tr_iade_iptal_s9_li4_pre = /** @type {(inputs: Iade_Iptal_S9_Li4_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayıtlı Elektronik Posta adresinizden`)
};

const en_iade_iptal_s9_li4_pre = /** @type {(inputs: Iade_Iptal_S9_Li4_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Written notice sent from your Registered Electronic Mail (KEP) address to`)
};

const de_iade_iptal_s9_li4_pre = /** @type {(inputs: Iade_Iptal_S9_Li4_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftliche Mitteilung, die von Ihrer KEP Adresse an`)
};

const ru_iade_iptal_s9_li4_pre = /** @type {(inputs: Iade_Iptal_S9_Li4_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Письменное уведомление, отправленное с вашего адреса KEP на адрес`)
};

/**
* | output |
* | --- |
* | "Written notice sent from your Registered Electronic Mail (KEP) address to" |
*
* @param {Iade_Iptal_S9_Li4_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s9_li4_pre = /** @type {((inputs?: Iade_Iptal_S9_Li4_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S9_Li4_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s9_li4_pre(inputs)
	if (locale === "de") return de_iade_iptal_s9_li4_pre(inputs)
	if (locale === "ru") return ru_iade_iptal_s9_li4_pre(inputs)
	return tr_iade_iptal_s9_li4_pre(inputs)
});